module.exports = __webpack_public_path__ + "img/C04TechTakabaraS.02ad597a.webp";